import { Component, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {FacilitiesPayorService} from '../../facilities-payor/facilities-payor.service';

@Component({
  selector: 'app-facility-multi-select',
  templateUrl: './facility-multi-select.component.html',
  styleUrls: ['./facility-multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FacilityMultiSelectComponent),
      multi: true
    }
  ]
})
export class FacilityMultiSelectComponent implements OnInit, ControlValueAccessor, OnChanges {
  @Input() emitOnlyId = false;
  @Input() isLoad = false;
  @Input() payersId = [];
  @Input() usersId?: any;
  @Output() currentListFac = new EventEmitter<any>();
  dropdownList =  [];
  selectedItems = [];

  dropdownSettings = {
    singleSelection: false,
    idField: 'facilityid',
    textField: 'description',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 5,
    allowSearchFilter: false
  };
  public objTmp = [];
  public propagateChange: any  = () => {};

  constructor(private facilityService: FacilitiesPayorService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.payersId.length !== 0) {
      this.facilityService.getListAllByPayorFacility(this.payersId)
        .finally(() => {
          if (this.selectedItems.length === 0) {
            this.selectedItems = this.updateDD(this.objTmp);
          } else {
            this.selectedItems = this.updateDD(this.selectedItems);
            this.objTmp = this.updateDD(this.selectedItems);
            this.currentListFac.emit(this.selectedItems);
          }
        })
        .subscribe((resp: any) => {
          this.dropdownList = this.mapingResp(resp);
        });
    }

    if (this.payersId.length === 0) {
      this.dropdownList =  [];
      this.selectedItems = [];
    }
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    if (obj) {
      this.objTmp = obj;
      if (this.selectedItems.length > 0) {
        this.selectedItems = this.updateDD(obj);
      }
    }
  }

  updateDD(obj) {
    const varValue = [];
      obj.map((item) => {
        this.dropdownList.map(f => {
          if (item.facilityid === f.facilityid) {
            varValue.push(f);
          }
        });
      });
    return varValue;
  }

  mapingResp(data) {
    const arrayResp = data.map((item) => {
      return {facilityid: item.facility.facilityid, description: item.facility.description};
    });
    return arrayResp;
  }

  /**
   * Propagate según Tipo
   */
  emitByType(event) {
    if (this.emitOnlyId) {
      this.propagateChange(event);
    } else {
      this.propagateChange(this.selectedItems);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/multi-select-dropdown/facility-multi-select/facility-multi-select.component.ts